var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.emailSent
        ? [
            _c(
              "default-layout",
              {
                attrs: {
                  title: _vm.t(
                    "AuthenticatedPage.RequireEmailVerification.heading"
                  ),
                  "sub-title": _vm.userIdentity.email,
                },
              },
              [
                _c("div", {
                  attrs: { "data-test": "verify-email-prompt-detail" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.t(
                        "AuthenticatedPage.RequireEmailVerification.detail",
                        {
                          email: _vm.userIdentity.email,
                          contactSupportUrl: _vm.contactSupportUrl,
                        }
                      )
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "my-6" },
                  [
                    _c(
                      "sm-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.sendEmailVerification },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.t(
                                "AuthenticatedPage.RequireEmailVerification.sendEmailVerification"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        : [
            _c(
              "default-layout",
              {
                attrs: {
                  title: _vm.t(
                    "AuthenticatedPage.CheckEmailVerification.heading"
                  ),
                  "sub-title": _vm.userIdentity.email,
                },
              },
              [
                _c("div", {
                  attrs: { "data-test": "verify-email-prompt-detail" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.t("AuthenticatedPage.CheckEmailVerification.detail")
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "my-6" },
                  [
                    _c(
                      "sm-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.emailSent = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.t(
                                "AuthenticatedPage.CheckEmailVerification.didNotReceiveTheEmail"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }